import React from 'react';
import withIcon from '../utilities/withIcon';

const IconBlocks = () => {
  return (
    <g>
      <path d="M15.2 15.95H.8a.75.75 0 0 1-.75-.75v-4.8a.75.75 0 0 1 .75-.75h4.05V5.6a.75.75 0 0 1 .75-.75h4.05V.8a.75.75 0 0 1 .75-.75h4.8a.75.75 0 0 1 .75.75v14.4a.75.75 0 0 1-.75.75zm-4.05-1.5h3.3v-3.3h-3.3zm-4.8 0h3.3v-3.3h-3.3zm-4.8 0h3.3v-3.3h-3.3zm9.6-4.8h3.3v-3.3h-3.3zm-4.8 0h3.3v-3.3h-3.3zm4.8-4.8h3.3v-3.3h-3.3z" />
    </g>
  );
};

export default withIcon(IconBlocks);
